import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Field } from 'redux-form';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import displayError from 'shared-components/reduxForms/utilities/displayError';
import { FormattedMessage } from 'react-intl';

const CleaningTypeFields = ({
  fields,
  meta,
  errorMessage,
  nameKey,
  initialValues
}) => {
  const { error, submitFailed } = meta;

  return (
    <div className="cleaning-sections">
      <h6>{fields.heading}</h6>
      <p className="text-gray-600 margin-xl-bottom"><FormattedMessage id="hosting.cleaning_type_fields.select_all_heading" defaultMessage="Select all that apply"/></p>
      {
        fields.items.map((option) => {
          return (
            <div key={option.key}>
              <Field
                id={option.key}
                className="margin-lg-bottom"
                component={CheckboxField}
                showErrorOnChange
                name={`${nameKey}[${option.key}]`}
                option={get(initialValues, [nameKey, option.key])}
                attributes={{
                  'data-testing-id': option.key
                }}
                label={
                  <span>{option.label}</span>
                }
              />
            </div>
          );
        })
      }
      {
        (error && submitFailed) && (
          <p className="error text-danger text-small" style={{ marginTop: '8px' }}>
            {displayError(errorMessage, error)}
          </p>
        )
      }
    </div>
  );
};

CleaningTypeFields.propTypes = {
  fields: PropTypes.array,
  meta: PropTypes.object,
  errorMessage: PropTypes.string,
  nameKey: PropTypes.string,
  initialValues: PropTypes.object
};

export default CleaningTypeFields;
